module.exports = __webpack_public_path__ + "static/media/1 22 love.18b7e432.mp3";